import {
  SCHEDULING_AVAILABILITY,
  SCHEDULING_AVAILABILITY_TIME_LABELS,
} from '../../constants'
import { APPOINTMENT_STATUS } from './scheduling.state'

export default {
  pcpsOnFile: (state) => state.pcpsOnFile,
  healthPlanRequiresPersonalDoctor: (state) =>
    state.healthPlanRequiresPersonalDoctor,
  selectedDoctors: (state) => state.selectedDoctors,
  selectedAvailability: (state) => state.selectedAvailability,
  getSelectedAvailabilityByDay: (state) => (day) => {
    return state.selectedAvailability[day]
  },
  userHasSelectedAvailability: (state) => {
    return Object.values(state.selectedAvailability).some((day) =>
      Object.values(day).some((time) => time)
    )
  },
  getAllSelectedTimeSlots: (state) => {
    const timeSlots = {
      [SCHEDULING_AVAILABILITY.TIMES.MORNING]: {
        label:
          SCHEDULING_AVAILABILITY_TIME_LABELS[
            SCHEDULING_AVAILABILITY.TIMES.MORNING
          ],
        description:
          SCHEDULING_AVAILABILITY_TIME_LABELS[
            SCHEDULING_AVAILABILITY.TIMES.MORNING
          ],
        days: [],
      },
      [SCHEDULING_AVAILABILITY.TIMES.MIDDAY]: {
        label:
          SCHEDULING_AVAILABILITY_TIME_LABELS[
            SCHEDULING_AVAILABILITY.TIMES.MIDDAY
          ],
        description:
          SCHEDULING_AVAILABILITY_TIME_LABELS[
            SCHEDULING_AVAILABILITY.TIMES.MIDDAY
          ],
        days: [],
      },
      [SCHEDULING_AVAILABILITY.TIMES.AFTERNOON]: {
        label:
          SCHEDULING_AVAILABILITY_TIME_LABELS[
            SCHEDULING_AVAILABILITY.TIMES.AFTERNOON
          ],
        description:
          SCHEDULING_AVAILABILITY_TIME_LABELS[
            SCHEDULING_AVAILABILITY.TIMES.AFTERNOON
          ],
        days: [],
      },
    }

    Object.entries(state.selectedAvailability).forEach(([day, times]) => {
      Object.entries(times).forEach(([time, isSelected]) => {
        if (isSelected) {
          timeSlots[time].days.push(day)
        }
      })
    })

    return Object.values(timeSlots).filter((slot) => slot.days.length > 0)
  },
  getListOfDoctors: (state) => {
    return state.recommendedDoctors
  },
  isDoctorSelected: (state) => (doctorId) => {
    return state.selectedDoctors.some((doctor) => doctor.id === doctorId)
  },
  getDoctorPreferenceValue: (state) => (doctor) => {
    return state.selectedDoctors.findIndex(
      (selectedDoctor) => selectedDoctor.id === doctor.id
    )
  },
  getDoctorPreferences: (state) => {
    return state.doctorPreferences
  },
  zipCode: (state) => {
    return state.zipCode
  },
  isFetchingProviders: (state) => {
    return state.isFetchingProviders
  },
  isFetchingPcpsOnFile: (state) => {
    return state.isFetchingPcpsOnFile
  },
  scheduledAppointment: (state) => {
    return state.scheduledAppointment
  },
  appointmentIsPending: (state) => {
    return (
      state.scheduledAppointment.status === APPOINTMENT_STATUS.QUEUED ||
      state.scheduledAppointment.status === APPOINTMENT_STATUS.IN_PROGRESS ||
      state.scheduledAppointment.status === APPOINTMENT_STATUS.TRIGGERED
    )
  },
  appointmentIsSuccess: (state) => {
    return state.scheduledAppointment.status === APPOINTMENT_STATUS.SUCCESS
  },
  appointmentIsCancelled: (state) => {
    return state.scheduledAppointment.status === APPOINTMENT_STATUS.CANCELLED
  },
  isFetchingScheduledAppointment: (state) => {
    return state.isFetchingScheduledAppointment
  },
  demoPhoneOverride: (state) => {
    return state.demoPhoneOverride
  },
}
